(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('GeneralConfigController', GeneralConfigController);
    

    GeneralConfigController.$inject = [
    
    ];

    function GeneralConfigController(){
         // jshint maxstatements:false
        var vm = this;

        vm.selected = { id: 0, nombre: ''};
        vm.data = [];
        vm.keepRecData = true;        
    }

})();